import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import ContentWrap, { SIZES } from '../ContentWrap';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * Wrapper with different sizes, so far just desktop size is available
 */
export default function ContentLiner({ children, isUnderlay, size, className, id }) {
  return (
    <div className={cx('component', { underlay: isUnderlay }, className)} id={id}>
      <ContentWrap size={size}>{children}</ContentWrap>
    </div>
  );
}

ContentLiner.propTypes = {
  children: PropTypes.node,
  isUnderlay: PropTypes.bool,
  size: PropTypes.arrayOf(PropTypes.oneOf([null, ...SIZES])),
  className: PropTypes.string,
  id: PropTypes.string,
};
